import * as Sentry from '@sentry/nuxt';
import consola from 'consola'
import { useRuntimeConfig } from '#imports';

const config = useRuntimeConfig();

consola.log('🔍 Sentry client config loading...', {
  dsn: config.public.sentryDsn ? 'SET' : 'NOT_SET',
  buildTarget: config.public.buildTarget,
  nodeEnv: process.env.NODE_ENV,
});

// Only run `init` when DSN is available
if (config.public.sentryDsn) {
  try {
    Sentry.init({
      dsn: config.public.sentryDsn,
      environment: process.env.NODE_ENV || 'development',
      release: `TasteOk@${process.env.npm_package_version || '1.0.21'}`,
      tracesSampleRate: 1,
      // Временно отключаем Session Replay для отладки
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      integrations: [
        // Минимальный набор интеграций для отладки
      ],
      initialScope: {
        tags: {
          component: 'frontend',
          version: process.env.npm_package_version || '1.0.21',
          build_target: config.public.buildTarget,
        },
      },
      beforeSend(event) {
        consola.log('📤 Sentry event:', event);
        return event;
      },
    });
    consola.log('✅ Sentry client initialized successfully');
  } catch (error) {
    consola.error('❌ Sentry initialization failed:', error);
  }
} else {
  consola.warn('⚠️ Sentry DSN not found, skipping initialization');
}
